import {PermissionUser} from './PermissionUser';

export default PermissionUser;
